import React from 'react';
import CustomPasswordReset from './CustomAuthComponents';
import SSOLogin from './SSOLogin';


const Footer = (props) => {
    // console.log(import.meta.env)
    //eslint-disable-next-line
    let whatever = import.meta.env;

    return ( import.meta?.env?.VITE_SSO ==="true" ? <SSOLogin color={props?.config?.data?.PrimaryColorParameter}/>
        : (window?.location?.pathname === '/password-reset' ? <CustomPasswordReset color={props?.config?.data?.PrimaryColorParameter}/>
            : <></>)
    );
};

export default Footer;